/** SCRUM-320 / LEG-HC-03: engineering-controlled classification, never editorial input. */
export const catalogueMarkets = ["GB", "US", "AE", "SA", "IN", "SG", "AU"] as const;
export type CatalogueMarket = (typeof catalogueMarkets)[number];

export const catalogueCategories = [
  {
    id: "identity-travel",
    label: "Identity & travel",
  },
  {
    id: "vehicle-transport",
    label: "Vehicle & transport",
  },
  {
    id: "insurance",
    label: "Insurance",
  },
  {
    id: "property-home",
    label: "Property & home",
  },
  {
    id: "utilities-telecoms",
    label: "Utilities & telecoms",
  },
  {
    id: "health-administration",
    label: "Health administration",
  },
  {
    id: "financial-tax",
    label: "Financial & tax",
  },
  {
    id: "subscriptions-memberships",
    label: "Subscriptions & memberships",
  },
  {
    id: "general-miscellaneous",
    label: "General",
  },
] as const;
export type CatalogueCategoryId = (typeof catalogueCategories)[number]["id"];

export const catalogueSubcategories = [
  {
    id: "travel-documents",
    label: "Travel documents",
    categoryId: "identity-travel",
  },
  {
    id: "residence-documents",
    label: "Residence documents",
    categoryId: "identity-travel",
  },
  {
    id: "identity-documents",
    label: "Identity documents",
    categoryId: "identity-travel",
  },
  {
    id: "travel-authorisations",
    label: "Travel authorisations",
    categoryId: "identity-travel",
  },
  {
    id: "work-authorisations",
    label: "Work authorisations",
    categoryId: "identity-travel",
  },
  {
    id: "address-administration",
    label: "Address administration",
    categoryId: "identity-travel",
  },
  {
    id: "driver-documents",
    label: "Driving documents",
    categoryId: "vehicle-transport",
  },
  {
    id: "vehicle-documents",
    label: "Vehicle documents",
    categoryId: "vehicle-transport",
  },
  {
    id: "vehicle-administration",
    label: "Vehicle administration",
    categoryId: "vehicle-transport",
  },
  {
    id: "parking-permits",
    label: "Parking permits",
    categoryId: "vehicle-transport",
  },
  {
    id: "maintenance-inspections",
    label: "Maintenance inspections",
    categoryId: "vehicle-transport",
  },
  {
    id: "roadside-cover",
    label: "Roadside cover",
    categoryId: "insurance",
  },
  {
    id: "toll-accounts",
    label: "Toll accounts",
    categoryId: "vehicle-transport",
  },
  {
    id: "vehicle-finance",
    label: "Vehicle finance",
    categoryId: "financial-tax",
  },
  {
    id: "home-finance",
    label: "Home finance",
    categoryId: "financial-tax",
  },
  {
    id: "credit-cards",
    label: "Card administration",
    categoryId: "financial-tax",
  },
  {
    id: "bank-administration",
    label: "Bank administration",
    categoryId: "financial-tax",
  },
  {
    id: "credit-reports",
    label: "Credit reports",
    categoryId: "financial-tax",
  },
  {
    id: "tax-filing",
    label: "Tax filing",
    categoryId: "financial-tax",
  },
  {
    id: "tax-payments",
    label: "Tax payments",
    categoryId: "financial-tax",
  },
  {
    id: "tax-statements",
    label: "Tax statements",
    categoryId: "financial-tax",
  },
  {
    id: "pension-administration",
    label: "Pension administration",
    categoryId: "financial-tax",
  },
  {
    id: "education-finance",
    label: "Student finance",
    categoryId: "financial-tax",
  },
  {
    id: "motor-cover",
    label: "Motor cover",
    categoryId: "insurance",
  },
  {
    id: "home-cover",
    label: "Home cover",
    categoryId: "insurance",
  },
  {
    id: "pet-cover",
    label: "Pet cover",
    categoryId: "insurance",
  },
  {
    id: "health-cover",
    label: "Health cover",
    categoryId: "insurance",
  },
  {
    id: "income-cover",
    label: "Income cover",
    categoryId: "insurance",
  },
  {
    id: "life-cover",
    label: "Life cover",
    categoryId: "insurance",
  },
  {
    id: "tenancy-contracts",
    label: "Tenancy contracts",
    categoryId: "property-home",
  },
  {
    id: "home-maintenance",
    label: "Home maintenance",
    categoryId: "property-home",
  },
  {
    id: "home-warranties",
    label: "Home warranties",
    categoryId: "property-home",
  },
  {
    id: "housing-charges",
    label: "Housing charges",
    categoryId: "property-home",
  },
  {
    id: "energy-contracts",
    label: "Energy contracts",
    categoryId: "utilities-telecoms",
  },
  {
    id: "cooling-contracts",
    label: "Cooling contracts",
    categoryId: "utilities-telecoms",
  },
  {
    id: "connectivity-contracts",
    label: "Connectivity contracts",
    categoryId: "utilities-telecoms",
  },
  {
    id: "utility-bill-dates",
    label: "Utility bill dates",
    categoryId: "utilities-telecoms",
  },
  {
    id: "administrative-certificates",
    label: "Administrative certificates",
    categoryId: "health-administration",
  },
  {
    id: "appointment-dates",
    label: "Appointment dates",
    categoryId: "health-administration",
  },
  {
    id: "plan-administration",
    label: "Plan administration",
    categoryId: "health-administration",
  },
  {
    id: "civic-administration",
    label: "Civic administration",
    categoryId: "general-miscellaneous",
  },
  {
    id: "personal-document-review",
    label: "Personal document reviews",
    categoryId: "general-miscellaneous",
  },
  {
    id: "everyday-dates",
    label: "Everyday tasks and dates",
    categoryId: "general-miscellaneous",
  },
  {
    id: "broadcast-licences",
    label: "TV licensing",
    categoryId: "subscriptions-memberships",
  },
  {
    id: "television-plans",
    label: "Television plans",
    categoryId: "subscriptions-memberships",
  },
  {
    id: "digital-plans",
    label: "Digital subscriptions",
    categoryId: "subscriptions-memberships",
  },
  {
    id: "fitness-memberships",
    label: "Fitness memberships",
    categoryId: "subscriptions-memberships",
  },
  {
    id: "shopping-memberships",
    label: "Shopping memberships",
    categoryId: "subscriptions-memberships",
  },
  {
    id: "existing-subscriptions",
    categoryId: "subscriptions-memberships",
    label: "Subscriptions",
  },
] as const;
export type CatalogueSubcategoryId = (typeof catalogueSubcategories)[number]["id"];

const typeDefinitions = {
  "personal-task": {
    categoryId: "general-miscellaneous",
    subcategoryId: "everyday-dates",
    label: "Task",
  },
  "personal-appointment": {
    categoryId: "general-miscellaneous",
    subcategoryId: "everyday-dates",
    label: "Appointment",
  },
  "personal-payment-date": {
    categoryId: "general-miscellaneous",
    subcategoryId: "everyday-dates",
    label: "Payment date",
  },
  passport: {
    categoryId: "identity-travel",
    subcategoryId: "travel-documents",
    label: "Passport",
  },
  "car-insurance": {
    categoryId: "insurance",
    subcategoryId: "motor-cover",
    label: "Car insurance",
  },
  "consumer-subscription": {
    categoryId: "subscriptions-memberships",
    subcategoryId: "existing-subscriptions",
    label: "Consumer subscription",
  },
  "residence-document-expiry": {
    categoryId: "identity-travel",
    subcategoryId: "residence-documents",
    label: "Residence document expiry",
  },
  "national-id-expiry": {
    categoryId: "identity-travel",
    subcategoryId: "identity-documents",
    label: "National ID expiry",
  },
  "travel-authorisation-expiry": {
    categoryId: "identity-travel",
    subcategoryId: "travel-authorisations",
    label: "Travel authorisation expiry",
  },
  "work-authorisation-document-expiry": {
    categoryId: "identity-travel",
    subcategoryId: "work-authorisations",
    label: "Work authorisation document expiry",
  },
  "identity-document-review": {
    categoryId: "identity-travel",
    subcategoryId: "identity-documents",
    label: "Identity document review",
  },
  "national-address-update": {
    categoryId: "identity-travel",
    subcategoryId: "address-administration",
    label: "National address update",
  },
  "driving-licence-expiry": {
    categoryId: "vehicle-transport",
    subcategoryId: "driver-documents",
    label: "Driving licence expiry",
  },
  "international-driving-permit-expiry": {
    categoryId: "vehicle-transport",
    subcategoryId: "driver-documents",
    label: "International driving permit expiry",
  },
  "vehicle-registration-expiry": {
    categoryId: "vehicle-transport",
    subcategoryId: "vehicle-documents",
    label: "Vehicle registration expiry",
  },
  "mot-expiry": {
    categoryId: "vehicle-transport",
    subcategoryId: "vehicle-documents",
    label: "MOT expiry",
  },
  "pollution-certificate-expiry": {
    categoryId: "vehicle-transport",
    subcategoryId: "vehicle-documents",
    label: "Pollution certificate expiry",
  },
  "vehicle-tax-date": {
    categoryId: "vehicle-transport",
    subcategoryId: "vehicle-administration",
    label: "Vehicle tax date",
  },
  "vehicle-logbook-address-update": {
    categoryId: "vehicle-transport",
    subcategoryId: "vehicle-administration",
    label: "Vehicle logbook address update",
  },
  "driver-record-address-update": {
    categoryId: "vehicle-transport",
    subcategoryId: "vehicle-administration",
    label: "Driver record address update",
  },
  "parking-permit-expiry": {
    categoryId: "vehicle-transport",
    subcategoryId: "parking-permits",
    label: "Parking permit expiry",
  },
  "blue-badge-expiry": {
    categoryId: "vehicle-transport",
    subcategoryId: "parking-permits",
    label: "Blue badge expiry",
  },
  "vehicle-service": {
    categoryId: "vehicle-transport",
    subcategoryId: "maintenance-inspections",
    label: "Vehicle service",
  },
  "vehicle-inspection": {
    categoryId: "vehicle-transport",
    subcategoryId: "maintenance-inspections",
    label: "Vehicle inspection",
  },
  "roadside-cover-renewal": {
    categoryId: "insurance",
    subcategoryId: "roadside-cover",
    label: "Roadside cover renewal",
  },
  "toll-account-review": {
    categoryId: "vehicle-transport",
    subcategoryId: "toll-accounts",
    label: "Toll account review",
  },
  "toll-account-information-update": {
    categoryId: "vehicle-transport",
    subcategoryId: "toll-accounts",
    label: "Toll account information update",
  },
  "vehicle-finance-contract-review": {
    categoryId: "financial-tax",
    subcategoryId: "vehicle-finance",
    label: "Vehicle finance contract review",
  },
  "mortgage-rate-review": {
    categoryId: "financial-tax",
    subcategoryId: "home-finance",
    label: "Mortgage rate review",
  },
  "mortgage-statement-review": {
    categoryId: "financial-tax",
    subcategoryId: "home-finance",
    label: "Mortgage statement review",
  },
  "card-promotional-period-end": {
    categoryId: "financial-tax",
    subcategoryId: "credit-cards",
    label: "Card promotional period end",
  },
  "payment-card-expiry": {
    categoryId: "financial-tax",
    subcategoryId: "credit-cards",
    label: "Payment card expiry",
  },
  "card-fee-review": {
    categoryId: "financial-tax",
    subcategoryId: "credit-cards",
    label: "Card fee review",
  },
  "reward-points-review": {
    categoryId: "financial-tax",
    subcategoryId: "credit-cards",
    label: "Reward points review",
  },
  "bank-benefits-review": {
    categoryId: "financial-tax",
    subcategoryId: "bank-administration",
    label: "Bank benefits review",
  },
  "bank-information-update": {
    categoryId: "financial-tax",
    subcategoryId: "bank-administration",
    label: "Bank information update",
  },
  "credit-report-review": {
    categoryId: "financial-tax",
    subcategoryId: "credit-reports",
    label: "Credit report review",
  },
  "personal-tax-return-date": {
    categoryId: "financial-tax",
    subcategoryId: "tax-filing",
    label: "Personal tax return date",
  },
  "personal-tax-payment-date": {
    categoryId: "financial-tax",
    subcategoryId: "tax-payments",
    label: "Personal tax payment date",
  },
  "property-tax-bill-date": {
    categoryId: "financial-tax",
    subcategoryId: "tax-payments",
    label: "Property tax bill date",
  },
  "tax-statement-review": {
    categoryId: "financial-tax",
    subcategoryId: "tax-statements",
    label: "Tax statement review",
  },
  "life-certificate-submission": {
    categoryId: "financial-tax",
    subcategoryId: "pension-administration",
    label: "Life certificate submission",
  },
  "pension-statement-review": {
    categoryId: "financial-tax",
    subcategoryId: "pension-administration",
    label: "Pension statement review",
  },
  "student-finance-application": {
    categoryId: "financial-tax",
    subcategoryId: "education-finance",
    label: "Student finance application",
  },
  "motor-third-party-cover-renewal": {
    categoryId: "insurance",
    subcategoryId: "motor-cover",
    label: "Motor third party cover renewal",
  },
  "motor-own-damage-cover-renewal": {
    categoryId: "insurance",
    subcategoryId: "motor-cover",
    label: "Motor own damage cover renewal",
  },
  "buildings-cover-renewal": {
    categoryId: "insurance",
    subcategoryId: "home-cover",
    label: "Buildings cover renewal",
  },
  "contents-cover-renewal": {
    categoryId: "insurance",
    subcategoryId: "home-cover",
    label: "Contents cover renewal",
  },
  "flood-cover-renewal": {
    categoryId: "insurance",
    subcategoryId: "home-cover",
    label: "Flood cover renewal",
  },
  "pet-cover-renewal": {
    categoryId: "insurance",
    subcategoryId: "pet-cover",
    label: "Pet cover renewal",
  },
  "health-cover-renewal": {
    categoryId: "insurance",
    subcategoryId: "health-cover",
    label: "Health cover renewal",
  },
  "employment-cover-renewal": {
    categoryId: "insurance",
    subcategoryId: "income-cover",
    label: "Employment cover renewal",
  },
  "life-cover-premium-date": {
    categoryId: "insurance",
    subcategoryId: "life-cover",
    label: "Life cover premium date",
  },
  "tenancy-contract-review": {
    categoryId: "property-home",
    subcategoryId: "tenancy-contracts",
    label: "Tenancy contract review",
  },
  "home-climate-service": {
    categoryId: "property-home",
    subcategoryId: "home-maintenance",
    label: "Home climate service",
  },
  "backflow-inspection": {
    categoryId: "property-home",
    subcategoryId: "home-maintenance",
    label: "Backflow inspection",
  },
  "home-warranty-review": {
    categoryId: "property-home",
    subcategoryId: "home-warranties",
    label: "Home warranty review",
  },
  "housing-society-bill-date": {
    categoryId: "property-home",
    subcategoryId: "housing-charges",
    label: "Housing society bill date",
  },
  "energy-tariff-review": {
    categoryId: "utilities-telecoms",
    subcategoryId: "energy-contracts",
    label: "Energy tariff review",
  },
  "district-cooling-contract-review": {
    categoryId: "utilities-telecoms",
    subcategoryId: "cooling-contracts",
    label: "District cooling contract review",
  },
  "broadband-contract-review": {
    categoryId: "utilities-telecoms",
    subcategoryId: "connectivity-contracts",
    label: "Broadband contract review",
  },
  "phone-contract-review": {
    categoryId: "utilities-telecoms",
    subcategoryId: "connectivity-contracts",
    label: "Phone contract review",
  },
  "connectivity-contract-review": {
    categoryId: "utilities-telecoms",
    subcategoryId: "connectivity-contracts",
    label: "Connectivity contract review",
  },
  "water-bill-date": {
    categoryId: "utilities-telecoms",
    subcategoryId: "utility-bill-dates",
    label: "Water bill date",
  },
  "electricity-bill-date": {
    categoryId: "utilities-telecoms",
    subcategoryId: "utility-bill-dates",
    label: "Electricity bill date",
  },
  "prescription-prepayment-expiry": {
    categoryId: "health-administration",
    subcategoryId: "administrative-certificates",
    label: "Prescription prepayment expiry",
  },
  "travel-health-card-expiry": {
    categoryId: "health-administration",
    subcategoryId: "administrative-certificates",
    label: "Travel health card expiry",
  },
  "eye-appointment-date": {
    categoryId: "health-administration",
    subcategoryId: "appointment-dates",
    label: "Eye appointment date",
  },
  "health-plan-benefits-review": {
    categoryId: "health-administration",
    subcategoryId: "plan-administration",
    label: "Health plan benefits review",
  },
  "jury-response-date": {
    categoryId: "general-miscellaneous",
    subcategoryId: "civic-administration",
    label: "Jury response date",
  },
  "voter-registration-update": {
    categoryId: "general-miscellaneous",
    subcategoryId: "civic-administration",
    label: "Voter registration update",
  },
  "personal-legal-document-review": {
    categoryId: "general-miscellaneous",
    subcategoryId: "personal-document-review",
    label: "Personal legal document review",
  },
  "broadcast-licence-renewal": {
    categoryId: "subscriptions-memberships",
    subcategoryId: "broadcast-licences",
    label: "Broadcast licence renewal",
  },
  "pay-tv-contract-review": {
    categoryId: "subscriptions-memberships",
    subcategoryId: "television-plans",
    label: "Pay TV contract review",
  },
  "video-streaming-plan-review": {
    categoryId: "subscriptions-memberships",
    subcategoryId: "digital-plans",
    label: "Video streaming plan review",
  },
  "music-plan-review": {
    categoryId: "subscriptions-memberships",
    subcategoryId: "digital-plans",
    label: "Music plan review",
  },
  "cloud-storage-plan-review": {
    categoryId: "subscriptions-memberships",
    subcategoryId: "digital-plans",
    label: "Cloud storage plan review",
  },
  "gaming-plan-review": {
    categoryId: "subscriptions-memberships",
    subcategoryId: "digital-plans",
    label: "Gaming plan review",
  },
  "software-plan-review": {
    categoryId: "subscriptions-memberships",
    subcategoryId: "digital-plans",
    label: "Software plan review",
  },
  "gym-membership-review": {
    categoryId: "subscriptions-memberships",
    subcategoryId: "fitness-memberships",
    label: "Gym membership review",
  },
  "shopping-membership-review": {
    categoryId: "subscriptions-memberships",
    subcategoryId: "shopping-memberships",
    label: "Shopping membership review",
  },
  "discount-membership-review": {
    categoryId: "subscriptions-memberships",
    subcategoryId: "shopping-memberships",
    label: "Discount membership review",
  },
  "homeowners-cover-renewal": {
    categoryId: "insurance",
    subcategoryId: "home-cover",
    label: "Homeowners cover renewal",
  },
  "renters-cover-renewal": {
    categoryId: "insurance",
    subcategoryId: "home-cover",
    label: "Renters cover renewal",
  },
} as const satisfies Readonly<
  Record<
    string,
    Readonly<{
      categoryId: CatalogueCategoryId;
      subcategoryId: CatalogueSubcategoryId;
      label: string;
    }>
  >
>;

export type CatalogueTypeId = keyof typeof typeDefinitions;
export const catalogueTypeIds: ReadonlyArray<CatalogueTypeId> = Object.freeze(
  Object.keys(typeDefinitions) as CatalogueTypeId[],
);
export const catalogueTypeLabels: Readonly<Record<CatalogueTypeId, string>> = Object.freeze(
  Object.fromEntries(catalogueTypeIds.map((type) => [type, typeDefinitions[type].label])) as Record<
    CatalogueTypeId,
    string
  >,
);

export function classifyReminderType(type: string): Readonly<{
  type: CatalogueTypeId;
  categoryId: CatalogueCategoryId;
  subcategoryId: CatalogueSubcategoryId;
  label: string;
}> {
  if (!Object.prototype.hasOwnProperty.call(typeDefinitions, type)) {
    throw new Error("Choose a supported reminder type.");
  }
  const id = type as CatalogueTypeId;
  return { type: id, ...typeDefinitions[id] };
}
